export async function createBeneficiaries(beneficiariesRepository, beneficiaries) {
  return beneficiariesRepository.save(beneficiaries);
};
